<template>
  <div>
    <building-permit-template />
    <h2 class="mt-4">{{ $t('summary-title') }}</h2>
    <p class="mb-4">{{ $t('home-intro') }}</p>
    <DatePicker v-if="start_date && end_date" v-on:set-year="handleYear" v-on:set-month="handleMonth" :from_date="start_date" :to_date="end_date" :set_year="selected_year" :set_month="selected_month"></DatePicker>
    
    <div v-if="hasDateParams">
      <h3>{{ $t('permit-summary-for',{text_date: textDate}) }}</h3>
      <glance-table
        :startDate="startDate"
        :endDate="endDate"
      />
      <activity-table-1
        :curYear="curYear"
        :startDate="startDate"
        :endDate="endDate"
      />
      <activity-table-2
        :curYear="curYear"
        :startDate="startDate"
        :endDate="endDate"
      />
      <community-table
        :curYear="curYear"
        :startDate="startDate"
        :endDate="endDate"
      />
      <construction-table
        :curYear="curYear"
        :startDate="startDate"
        :endDate="endDate"
      />
      <demolition-table
        :curYear="curYear"
        :startDate="startDate"
        :endDate="endDate"
      />
      <major-projects
        :curYear="curYear"
        :startDate="startDate"
        :endDate="endDate"
      />
    </div>
    <p class="mb-4"><a href="https://data.winnipeg.ca/Development-Approvals-Building-Permits-Inspections/Building-permits-summary-aggregate-data/kdey-aemp/about_data">{{ $t('data-source') }}</a></p>
    
  </div>
</template>

<script>

import GlanceTable from '@/components/GlanceTable';
import ActivityTable1 from "@/components/ActivityTable1";
import ActivityTable2 from "@/components/ActivityTable2";
import CommunityTable from "@/components/CommunityTable";
import ConstructionTable from "@/components/ConstructionTable";
import DemolitionTable from "@/components/DemolitionTable";
import MajorProjects from "@/components/MajorProjects";
import DatePicker from '@/components/DatePicker';
import axios from 'axios';
import BuildingPermitTemplate from '@/components/BuildingPermitTemplate';
export default {

  components: {
    GlanceTable,
    ActivityTable1,
    ActivityTable2,
    CommunityTable,
    ConstructionTable,
    DemolitionTable,
    MajorProjects,
    DatePicker,
    BuildingPermitTemplate,
  },

  data() {
    return {
      start_date: null,
      end_date: null,
      selected_month: "",
      selected_year: "",
    }
  },

  async created() {
    if (this.$route.params.year) {
      this.selected_year = "" + this.$route.params.year;
    }
    if (this.$route.params.month) {
      this.selected_month = "" + this.$route.params.month;
    }
    const url = this.$PERMIT_API + "?$select=min(issue_date) as start_date,max(issue_date) as end_date";
    const { data } = await axios.get(url);
    if (data.length) {
      const minDate = new Date(data[0].start_date);
      this.start_date = new Date(minDate.setFullYear(minDate.getFullYear() + 1));
      this.end_date = new Date(data[0].end_date);
    }
  },

  computed: {

    hasDateParams() {
      return this.$route.params.year && this.$route.params.month;
    },

    textDate() {
      if (!this.hasDateParams) return '';
      const cur_date = new Date(this.curYear,this.curMonth-1);
      const options = { year: 'numeric', month: 'long' };
      return cur_date.toLocaleDateString('en-CA',options);
    },

    curYear() {
      return this.$route.params.year ? this.$route.params.year + "" : "";
    },
    curMonth() {
      return this.$route.params.month || "";
    },

    endDate() {
      if (!this.hasDateParams) return "";
      return this.$route.params.year + "-" + this.$route.params.month;
    },

    startDate() {
      if (!this.hasDateParams) return "";
      return (parseInt(this.$route.params.year,10) - 1) + "-" + this.$route.params.month;
    },
  },

  methods: {
    handleYear(value) {
      this.selected_year = "" + value;
      if (!value) {
        this.selected_month = "";
      }
      if (this.selected_month) {
        const select_date = new Date(this.selected_year + '-' + this.selected_month);
        if (select_date > this.end_date) {
          this.selected_month = "";
        }
      }
      this.handleDate();
    },

    handleMonth(value) {
      this.selected_month = "" + value;
      this.handleDate();
    },

    handleDate() {
      const targetRoute = this.selected_month && this.selected_year 
        ? { name: 'summary', params: { year: this.selected_year, month: this.selected_month } }
        : { name: 'summary' };
      
      // Check if we're already on the target route to avoid redundant navigation
      const currentRoute = this.$route;
      const isSameRoute = currentRoute.name === targetRoute.name && 
        currentRoute.params.year === targetRoute.params?.year && 
        currentRoute.params.month === targetRoute.params?.month;
      
      if (!isSameRoute) {
        this.$router.replace(targetRoute);
      }
    }
  }

}

</script>
